import React from "react";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
import DeleteButton from "../deleteButton/deleteButton.js";
import IntInput from "../intInput/intInput.js";
import Provider from "./Provider.js";
import LabeledSelect from "../labeledSelect/labeledSelect.js";
import { tierCountScopeNames } from "./priceModes.js";
const scopeOptions = Object.keys(tierCountScopeNames).map((scope) => ({ value: scope, label: tierCountScopeNames[scope] }));
export default function TiersProvider(props) {
    var _a;
    const { provider } = props;
    if (provider.tiers === undefined) {
        props.onProviderUpdate({
            type: "per-item-tiers-provider",
            tiers: [],
            priceForAllNext: { type: "constant", value: 15 },
        });
        return React.createElement(React.Fragment, null);
    }
    function updateTier(index, value) {
        props.onProviderUpdate({
            ...provider,
            tiers: provider.tiers.map((tier, i) => (i !== index ? tier : value)),
        });
    }
    return (React.createElement("div", { className: "" },
        React.createElement(LabeledSelect, { label: "Licz sztuki", options: scopeOptions, state: scopeOptions.findIndex((o) => { var _a; return o.value === ((_a = provider.countScope) !== null && _a !== void 0 ? _a : "line"); }), disableChangeEventOnFirstRender: true, onChange: (newScope) => props.onProviderUpdate({ ...provider, countScope: newScope }) }), (_a = provider.tiers) === null || _a === void 0 ? void 0 :
        _a.map((tier, index) => (React.createElement("div", { className: "tier-provider-tier", key: index },
            React.createElement("div", null,
                React.createElement("div", { className: "match-condition-part" }, index === 0 ? "Pierwsze " : "Kolejne "),
                React.createElement(IntInput, { defaultValue: tier.next, label: "Sztuk", onChange: (newNumber) => updateTier(index, { ...tier, next: newNumber }) })),
            React.createElement("div", null,
                React.createElement("div", null, "W cenie"),
                React.createElement(Provider, { provider: tier.price, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => {
                        return updateTier(index, { ...tier, price: newP });
                    }, formatNames: props.formatNames }),
                React.createElement("div", null, "Za sztuk\u0119")),
            React.createElement(DeleteButton, { onClick: () => props.onProviderUpdate({
                    ...provider,
                    tiers: provider.tiers.filter((_, i) => i !== index),
                }) })))),
        React.createElement("br", null),
        React.createElement(Button, { text: "Dodaj nowy skok cenowy", version: "transparent-stylish-old", value: "add-new-element", onClick: () => props.onProviderUpdate({
                ...provider,
                tiers: [
                    ...provider.tiers,
                    {
                        next: 5,
                        price: { type: "constant", value: 15 },
                    },
                ],
            }) }),
        React.createElement("div", { className: "match-condition-part" }, "Ka\u017Cde kolejne"),
        React.createElement(Provider, { provider: provider.priceForAllNext, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => props.onProviderUpdate({
                ...provider,
                priceForAllNext: newP,
            }), formatNames: props.formatNames }),
        React.createElement("div", { className: "match-condition-part" }, "Za sztuk\u0119")));
}
